<ng-container
  *appLet="{
    firstDate: firstDate$ | async,
    secondDate: secondDate$ | async,
    isOpen: isOpen$ | async,
    isSkipped: isSkipped$ | async,
    isSingleDate: isSingleDate$ | async,
    culture: culture$ | async,
  } as $comp"
>
  <div class="date-range-picker-desktop">
    <div
      class="date-range-picker-desktop__input date-range-picker-desktop__input--first"
      [ngClass]="{ 'date-range-picker-desktop__input--single': $comp.isSingleDate }"
      (click)="onFirstDateClick()"
    >
      <app-svg-icon
        icon="calendar"
        fill="voyage-blue"
        [width]="16"
        [height]="16">
      </app-svg-icon>
      @if ($comp.isSkipped) {
        <span>{{ skipText }}</span>
      } @else if ($comp.firstDate) {
        <span>{{ $comp.firstDate.toJSDate() | date: DATE_FORMAT_DEFAULT : undefined : $comp.culture || FALLBACK_CULTURE }}</span>
      } @else {
        <span>{{ firstDatePlaceholder }}</span>
      }
    </div>
    @if (!$comp.isSkipped && !$comp.isSingleDate) {
      <div
        class="date-range-picker-desktop__input date-range-picker-desktop__input--second"
        (click)="onSecondDateClick()"
      >
        <app-svg-icon
          fill="voyage-blue"
          icon="calendar"
          [width]="16"
          [height]="16">
        </app-svg-icon>
        @if ($comp.secondDate) {
          <span>{{ $comp.secondDate.toJSDate() | date: DATE_FORMAT_DEFAULT : undefined : $comp.culture || FALLBACK_CULTURE }}</span>
        } @else {
          <span>{{ secondDatePlaceholder }}</span>
        }
      </div>
    }
  </div>
  <app-date-range-picker-desktop-modal
    [skipText]="skipText"
    [noSkipText]="noSkipText"
  ></app-date-range-picker-desktop-modal>
</ng-container>
